import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
let AddressModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('number'), _dec6 = attr('number'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('string', {
  defaultValue: 'Italia'
}), _dec13 = attr('string'), _dec14 = attr('string'), _dec15 = attr('string'), _dec16 = attr('string'), _dec17 = attr('boolean'), _dec18 = attr('boolean'), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('number'), _dec22 = attr('string'), _dec23 = attr('boolean', {
  defaultValue: false
}), _class = class AddressModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "icon", _descriptor2, this);
    _initializerDefineProperty(this, "view", _descriptor3, this);
    _initializerDefineProperty(this, "place_id", _descriptor4, this);
    _initializerDefineProperty(this, "location_position_lat", _descriptor5, this);
    _initializerDefineProperty(this, "location_position_lng", _descriptor6, this);
    _initializerDefineProperty(this, "location_address_text", _descriptor7, this);
    _initializerDefineProperty(this, "location_address_house", _descriptor8, this);
    _initializerDefineProperty(this, "location_address_street", _descriptor9, this);
    _initializerDefineProperty(this, "location_address_postal_code", _descriptor0, this);
    _initializerDefineProperty(this, "location_address_city", _descriptor1, this);
    _initializerDefineProperty(this, "location_address_county", _descriptor10, this);
    _initializerDefineProperty(this, "location_address_state", _descriptor11, this);
    _initializerDefineProperty(this, "location_address_country", _descriptor12, this);
    _initializerDefineProperty(this, "location_address_country_code", _descriptor13, this);
    _initializerDefineProperty(this, "categories_id", _descriptor14, this);
    _initializerDefineProperty(this, "categories_title", _descriptor15, this);
    _initializerDefineProperty(this, "type", _descriptor16, this);
    _initializerDefineProperty(this, "is_invoice", _descriptor17, this);
    _initializerDefineProperty(this, "is_consegna", _descriptor18, this);
    _initializerDefineProperty(this, "piano", _descriptor19, this);
    _initializerDefineProperty(this, "notes", _descriptor20, this);
    _initializerDefineProperty(this, "accuracy", _descriptor21, this);
    _initializerDefineProperty(this, "heading", _descriptor22, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor23, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "icon", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "view", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "place_id", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "location_position_lat", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "location_position_lng", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "location_address_text", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "location_address_house", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "location_address_street", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "location_address_postal_code", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "location_address_city", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "location_address_county", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "location_address_state", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "location_address_country", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "location_address_country_code", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "categories_id", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "categories_title", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "is_invoice", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "is_consegna", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "piano", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "accuracy", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "heading", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { AddressModel as default };
//# sourceMappingURL=address.js.map
